import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CorrelationIdService } from '../services/correlation-id.service';

@Injectable()
export class CorrelationIdHttpInterceptor implements HttpInterceptor {
  constructor(private correlationIdService: CorrelationIdService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    const correlationId = this.correlationIdService.getCorrelationIdAndReset();

    if (correlationId) {
      request = request.clone({
        setHeaders: {
          'x-correlation-id': correlationId,
        },
      });
    }

    return next.handle(request);
  }
}
